import { http } from 'connex-cds';

export default {
  getOrderDetails: ({ entityRef, orderRef, code }) =>
    http.get({ apiName: 'cxp-view', path: `/${entityRef}/orders/${orderRef}/order?code=${code}` }),
  getOrderLocationsMap: ({ entityRef, orderRef, code }) =>
    http.get({ apiName: 'cxp-view', path: `/${entityRef}/orders/${orderRef}/locations?code=${code}` }),
};
